import { forwardRef } from "react";

import { Icon, IconProps } from "../icon";

export type UserGroupSolidIconProps = IconProps;

export const UserGroupSolidIcon = forwardRef<
  SVGSVGElement,
  UserGroupSolidIconProps
>(function UserGroupSolidIcon(props: UserGroupSolidIconProps, ref) {
  return (
    <Icon
      data-testid="UserGroupSolidIcon"
      aria-label="user group solid"
      viewBox="0 0 12 12"
      ref={ref}
      {...props}
    >
      <path d="M0 12h9v-.913a1.75 1.75 0 0 0-.376-1.106 1.792 1.792 0 0 0-.935-.655 8.833 8.833 0 0 0-.688-.225c-.036-.007-.079-.018-.129-.032s-.118-.036-.204-.064c-.064-.014-.125-.029-.183-.043-.05-.021-.1-.039-.15-.054-.48-.143-.841-.308-1.085-.494s-.394-.426-.451-.72c.215-.222.412-.487.591-.795s.329-.637.451-.988a7.08 7.08 0 0 0 .301-1.074c.072-.372.107-.734.107-1.085 0-.501-.072-.927-.215-1.278s-.34-.634-.591-.849a2.199 2.199 0 0 0-.87-.473c-.337-.1-.695-.15-1.074-.15s-.738.05-1.074.15A2.199 2.199 0 0 0 .964 2.474c-.143.351-.215.777-.215 1.278 0 .351.036.713.107 1.085.072.365.172.723.301 1.074.122.351.272.68.451.988s.376.573.591.795c-.057.294-.208.534-.451.72s-.605.351-1.085.494c-.05.014-.1.032-.15.054-.057.014-.118.029-.183.043a4.23 4.23 0 0 1-.331.096v2.901z" />
      <path d="M9.5 12H12V9.666a3.95 3.95 0 0 0-.24-.065 2.777 2.777 0 0 1-.167-.053c-.053-.012-.103-.023-.149-.035a1.008 1.008 0 0 0-.123-.044c-.393-.117-.688-.252-.888-.404s-.322-.349-.369-.589c.176-.182.337-.398.483-.65s.269-.521.369-.809c.106-.287.188-.58.246-.879a4.67 4.67 0 0 0 .088-.888c0-.41-.059-.759-.176-1.046s-.278-.519-.483-.694a1.786 1.786 0 0 0-.712-.387C9.604 3.041 9.311 3 9 3s-.604.041-.879.123a1.786 1.786 0 0 0-1.195 1.081c-.117.287-.176.636-.176 1.046 0 .287.029.583.088.888.059.299.141.592.246.879.1.287.223.557.369.809s.308.469.483.65a.94.94 0 0 1-.144.353l.066.026c.471.148.862.425 1.162.822.319.411.479.887.479 1.411v.913z" />
    </Icon>
  );
});
